import { Locales } from './locales'
import store from '@/store'

import enGB from './locales/en-GB.json'
import esES from './locales/es-ES.json'
import ptBR from './locales/pt-BR.json'

export const messages = {
  [Locales.enGB]: enGB,
  [Locales.esES]: esES,
  [Locales.ptBR]: ptBR
}

function getBrowserLocale() {
  const userPreferences = localStorage.getItem('userLocale')
  let navigatorLocale: any = ''
  if (userPreferences) {
    navigatorLocale = userPreferences
  } else {
    if (navigator.languages !== undefined) {
      navigatorLocale = navigator.languages[0]
    } else {
      navigatorLocale = navigator.language
    }
  }

  if (!navigatorLocale) {
    return undefined
  }

  const trimmedLocale = navigatorLocale.trim()

  if (Object.keys(messages).includes(trimmedLocale)) {
    store.commit('SET_ACTIVE_LANG', trimmedLocale)
    return trimmedLocale
  } else {
    store.commit('SET_ACTIVE_LANG', 'en-GB')
    return 'en-GB'
  }
}

export const defaultLocale = getBrowserLocale()
